<template>
  <div class="deviceDetail">
    <!-- <div class="top">
      <span class="top-info">
        <span class="label">
          <i class="status-icon" :class="deviceStatus.class"></i>
          {{deviceStatus.label}}
        </span>
        <span class="name">
          {{$t("device.deviceName")}}：
          {{deviceInfo.devalias || deviceInfo.sn}}
          <i style="font-size:15px;top:30px;left:22px;color:#1DD570;margin-left:10px;" class="iconfont icon-edit"></i>
        </span>
      </span>
      <ul class="top-operate">
        <li>操作</li>
      </ul>
    </div> -->
    <deviceoperate v-if="$store.state.device.isShow == 1"></deviceoperate>
    <ul class="tab" v-if="$store.state.device.isShow == 1">
      <!-- @click="activeTab=key;" -->
      <li class="tab-item" v-for="(value, key) in tabs" :key="key" :class="{ active: activeTab == key }"
        @click="changeTab(key)">{{ value }}</li>
    </ul>
    <component v-if="$store.state.device.isShow == 1" @collectionUPEvent="handleCollectionUPEvent" :is="activeTab" class="content"></component>

    <upgrade v-if="$store.state.device.isShow == 2"></upgrade>
    <upgradeUPG v-if="$store.state.device.isShow == 7"></upgradeUPG>
    <upgradeTypeUPG v-if="$store.state.device.isShow == 8"></upgradeTypeUPG>
    <!-- 采集频率加速页面--数据明细collectionUPPage=2 能流=1 -->
    <collectionUP v-if="$store.state.device.isShow == 9"  :collectionUPPage.sync="collectionUPTypeVal" :gprsType="gprsTypeVal" :rechargeFlagObj="rechargeFlagObj"></collectionUP>

    <collectorUpgrade v-if="$store.state.device.isShow == 3"></collectorUpgrade>
    <dataloggerDebug v-if="$store.state.device.isShow == 4"></dataloggerDebug>
    <deviceDebug v-if="$store.state.device.isShow == 5"></deviceDebug>

  </div>
</template>
<script>
import statistic from './statisticnew'
import chart from './chart'
import analysis from './analysis'
import clause from './clause'
// import Protocol from './Protocol'
import device from './deviceindex'
import deviceoperate from './deviceoperate'
import alarm from '../../../alarmnew'
import upgrade from './upgrade'
import upgradeUPG from './upgradeUPG'
import upgradeTypeUPG from './upgradeTypeUPG'
import collectionUP from './collectionFrequencyUP'
import collectorUpgrade from './collectorUpgrade'
import dataloggerDebug from './dataloggerDebug'
import deviceDebug from './deviceDebug'

import { mapGetters } from 'vuex'
export default {
  components: {
    statistic,
    chart,
    analysis,
    clause,
    // Protocol
    device,
    deviceoperate,
    alarm,
    upgrade,
    upgradeUPG,
    upgradeTypeUPG,
    collectionUP,
    collectorUpgrade,
    dataloggerDebug,
    deviceDebug,
  },
  data () {
    return {
      tabs: {
        statistic: this.$t('device.energyFlow'),
        device: this.$t('device.deviceInfo'),
        chart: this.$t('device.chart'),
        analysis: this.$t('device.analysis'),
        // Protocol: this.$t('device.Current_data'),
        clause: this.$t('device.clause'),
        alarm: this.$t('device.alarmInfo'),
      },
      activeTab: this.$route.query.tab || 'statistic', // 当前选中标签页序列号
      // paramObject:null,//右侧实时数据的总数
      collectionUPTypeVal:2,//采集频率加速页面 1能流 2数据明细
      gprsTypeVal: '',//设备通信类型
      rechargeFlagObj: null,//采集充值标志对象
    }
  },
  watch: {
    "$route.query.tab" (val) {
      this.activeTab = val || this.activeTab;
    },
  },
  created(){
    this.$store.commit('saveIsShow',1)
  },
  computed: {
    ...mapGetters({
      deviceInfo: 'getDeviceInfo',
      getIsShow: "getIsShow",
    }),
    deviceStatus () {
      return this.$filter.deviceStatus[this.deviceInfo.status]
    }
  },
  methods: {
    handleCollectionUPEvent(val){
      this.collectionUPTypeVal = val.collectionUPType;
      this.gprsTypeVal = val.gprsType;
      this.rechargeFlagObj = val.rechargeFlagObj;
      console.log(val, "1111111")
    },
    // Tab切换
    changeTab (key) {
      // "http://www.xxx.com/?pn=0"; 删 tab=alarm
      // let res = this.delurlquery(window.location.href, "tab");
      // //  发现使用History 模式会导致页面刷新，，无法切换
      // // window.location.href = res;
      // // 使用 pushState 更新浏览器 URL，而不刷新页面
      // window.history.pushState({}, "", res);
      let query = { ...this.$route.query }; // 复制当前的查询参数
      delete query.tab; // 删除 'tab' 参数
      this.$router.push({ query }); // 导航到更新后的查询参数
      this.activeTab = key;
    },
    // // 拼正则表达式字符串时消除原字符串中特殊字符干扰
    // escapereg (str) {
    //   // return str.replace(new RegExp("([.*+?^=!:\x24{}()|[\\]\/\\\\])", "g"), "\\\x241");
    //   return str.replace(/([.*+?^=!:${}()|[\]/\\])/g, '\\$1');
    // },
    // // 删url指定query
    // delurlquery (url, key) {
    //   key = this.escapereg(key);
    //   var reg = new RegExp("((\\?)(" + key + "=[^&]*&)+(?!" + key + "=))|(((\\?|&)" + key + "=[^&]*)+$)|(&" + key + "=[^&]*)", "g");
    //   return url.replace(reg, "\x241")
    // }
  }
}
</script>
<style lang="less" scoped>
@import url('../../../../assets/css/mixin.less');

.section {
  border-radius: 0;
  margin-top: 15px;
}

.deviceDetail {
  // background: rgb(34, 45, 53);
  display: flex;
  flex-direction: column;
  margin: 20px;
  // margin: 24px 24px 50px 24px;
  border-radius: 0px;
  padding: 0px;

  .top {
    padding: 5px 15px 5px 10px;
    display: flex;
    // margin-bottom: 10px;
    justify-content: space-between;
    align-items: center;
    background: #202D35;

    .name {
      .sc(16px, #fff);
      font-weight: bold;
    }

    .top-info {
      display: flex;
      align-items: center;
      justify-content: flex-start;

      .label {
        // padding: 5px 20px;
        // border-radius: 25px;
        // box-shadow: 0px -1px 2.5px #7F7F7F;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-between;
        // margin: 0 10px;
        // padding: 0px 20px;
        height: 32px;
        // background-color: #fff;
        // border: 1px solid #000;
        // border-radius: 18px;
        // box-shadow: inset 0px 0px 5px 1px #ccc;
        .sc(14px, #333);

        .status-icon {
          width: 12px;
          height: 12px;
          background-color: #1DD570;
          margin: 0 14px 0 18px;
          box-shadow: 1px 1px 3px #1DD570;
        }
      }
    }

    // .top-operate {}
  }

  .tab {
    // padding: 5px;
    display: flex;
    // border-bottom: 1px solid #d9d9d9;
    // background: #EAF0F2;
    background: rgb(34, 45, 53);

    &-item {
      margin: 0px;
      // padding: 11px 31px;
      padding: 1.2vh 31px;
      .sc(16px, rgba(123, 131, 149, 1));
      // font-weight: 600;
      // border: 1px solid #16D09A;
      border-bottom: none;
      cursor: pointer;

      &.active {
        // border-radius: 4px;
        // background: @themeColor;
        color: rgba(51, 255, 182, 1);
        border-bottom: 1px solid rgba(51, 255, 182, 1);
      }

      &:hover {
        // border-color: @themeColor;
        // color: @themeColor;
        // color: @hoverColor;
        color: #ffffff;
        background: @primaryColorTransparency30;
        // font-weight: 900;
      }
    }
  }

  .content {
    flex: 1;
    display: flex;
    // flex-direction: row;
    // [XM调整布局]
    overflow: auto;
  }

  .deviceinfobox.content {
    overflow: unset;
  }
}</style>